var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"toast",attrs:{"border":"left","color":_vm.color,"elevation":"10","type":_vm.type}},[_vm._v(" "+_vm._s(_vm.body)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }